import { useEffect, type PropsWithChildren } from 'react'
import { markAppReady } from '../register-app-updates'
import { BaseShell } from './base-shell'

export function Shell(props: PropsWithChildren) {
  useEffect(() => { markAppReady() }, [])
  return <BaseShell>{props.children}</BaseShell>
}
